var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.80167C12.67 1.80167 12.9867 1.81167 14.0408 1.86C15.1308 1.91 16.2533 2.15833 17.0475 2.9525C17.8492 3.75417 18.09 4.86583 18.14 5.95917C18.1883 7.01333 18.1983 7.33 18.1983 10C18.1983 12.67 18.1883 12.9867 18.14 14.0408C18.0908 15.125 17.8367 16.2583 17.0475 17.0475C16.2458 17.8492 15.135 18.09 14.0408 18.14C12.9867 18.1883 12.67 18.1983 10 18.1983C7.33 18.1983 7.01333 18.1883 5.95917 18.14C4.88333 18.0908 3.735 17.8308 2.9525 17.0475C2.155 16.25 1.91 15.1275 1.86 14.0408C1.81167 12.9867 1.80167 12.67 1.80167 10C1.80167 7.33 1.81167 7.01333 1.86 5.95917C1.90917 4.87917 2.16583 3.73917 2.9525 2.9525C3.7525 2.1525 4.86833 1.91 5.95917 1.86C7.01333 1.81167 7.33 1.80167 10 1.80167ZM10 0C7.28417 0 6.94333 0.0116667 5.87667 0.06C4.33083 0.130833 2.79583 0.560833 1.67833 1.67833C0.556667 2.8 0.130833 4.33167 0.06 5.87667C0.0116667 6.94333 0 7.28417 0 10C0 12.7158 0.0116667 13.0567 0.06 14.1233C0.130833 15.6675 0.5625 17.2067 1.67833 18.3217C2.79917 19.4425 4.33333 19.8692 5.87667 19.94C6.94333 19.9883 7.28417 20 10 20C12.7158 20 13.0567 19.9883 14.1233 19.94C15.6683 19.8692 17.205 19.4383 18.3217 18.3217C19.4442 17.1992 19.8692 15.6683 19.94 14.1233C19.9883 13.0567 20 12.7158 20 10C20 7.28417 19.9883 6.94333 19.94 5.87667C19.8692 4.33083 19.4383 2.795 18.3217 1.67833C17.2025 0.559167 15.6642 0.13 14.1233 0.06C13.0567 0.0116667 12.7158 0 10 0Z",
    fill: "url(#paint0_linear_2149_2727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 4.86499C7.1644 4.86499 4.86523 7.16416 4.86523 9.99999C4.86523 12.8358 7.1644 15.135 10.0002 15.135C12.8361 15.135 15.1352 12.8358 15.1352 9.99999C15.1352 7.16416 12.8361 4.86499 10.0002 4.86499ZM10.0002 13.3333C8.1594 13.3333 6.6669 11.8408 6.6669 9.99999C6.6669 8.15916 8.1594 6.66666 10.0002 6.66666C11.8411 6.66666 13.3336 8.15916 13.3336 9.99999C13.3336 11.8408 11.8411 13.3333 10.0002 13.3333Z",
    fill: "url(#paint1_linear_2149_2727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3387 5.86167C16.0014 5.86167 16.5387 5.32441 16.5387 4.66167C16.5387 3.99893 16.0014 3.46167 15.3387 3.46167C14.6759 3.46167 14.1387 3.99893 14.1387 4.66167C14.1387 5.32441 14.6759 5.86167 15.3387 5.86167Z",
    fill: "url(#paint2_linear_2149_2727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2149_2727",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#B7961E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EE2A7B",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6228D7",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2149_2727",
    x1: 10.0002,
    y1: 4.86499,
    x2: 10.0002,
    y2: 15.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#B7961E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EE2A7B",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6228D7",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2149_2727",
    x1: 15.3387,
    y1: 3.46167,
    x2: 15.3387,
    y2: 5.86167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#B7961E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EE2A7B",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6228D7",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.b6d45a61384adb843e39434e4fb012d2.svg";
export { ForwardRef as ReactComponent };